import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "p"
  }, [_c('div', {
    staticClass: "p_toolbar"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" 重新整理 ")]), _vm.fetchedAtText ? _c('span', {
    staticClass: "p_stamp"
  }, [_vm._v(" 資料時間 " + _vm._s(_vm.fetchedAtText) + " "), _vm.stale ? _c('b-badge', {
    staticClass: "ml-1",
    attrs: {
      "variant": "danger",
      "title": "超過 15 分鐘未收到新資料，請洽資訊人員。本平台全天更新，非日落所致"
    }
  }, [_vm._v(" 資料停止更新 ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._l(_vm.errors, function (e, i) {
    return _c('b-alert', {
      key: "err".concat(i),
      staticClass: "mx-1 my-2 py-2",
      attrs: {
        "show": "",
        "variant": "danger"
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle mr-1"
    }), _vm._v(_vm._s(e.msg) + " ")]);
  }), _vm.loading && !_vm.plants.length ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : _vm._e(), _c('b-alert', {
    staticClass: "text-center mx-1 my-4",
    attrs: {
      "show": !_vm.loading && !_vm.plants.length && !_vm.errors.length,
      "variant": "secondary"
    }
  }, [_vm._v(" 目前沒有資料，請洽資訊人員確認資料收集狀態。 ")]), _vm.plants.length ? [_c('div', {
    staticClass: "p_kpis"
  }, _vm._l(_vm.kpis, function (k) {
    return _c('div', {
      key: k.label,
      staticClass: "p_kpi",
      class: k.tone
    }, [_c('div', {
      staticClass: "p_kpi_label"
    }, [_vm._v(" " + _vm._s(k.label) + " "), k.hint ? _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-circle-info p_info",
      attrs: {
        "title": k.hint
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "p_kpi_value"
    }, [_vm._v(_vm._s(k.value)), _c('small', [_vm._v(_vm._s(k.unit))])])]);
  }), 0), _c('div', {
    staticClass: "p_section"
  }, [_c('div', {
    staticClass: "p_sectionTitle"
  }, [_c('i', {
    staticClass: "fas fa-triangle-exclamation"
  }), _vm._v(" 異常與提示 "), _vm.faultCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger",
      "pill": ""
    }
  }, [_vm._v("故障 " + _vm._s(_vm.faultCount))]) : _vm._e(), _vm.warnCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "warning",
      "pill": ""
    }
  }, [_vm._v("注意 " + _vm._s(_vm.warnCount))]) : _vm._e(), _vm.infoCount ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary",
      "pill": ""
    }
  }, [_vm._v("提示 " + _vm._s(_vm.infoCount))]) : _vm._e(), _c('small', {
    staticClass: "p_hint"
  }, [_vm._v("告警明細由監控平台即時提供")])], 1), !_vm.allAlerts.length ? _c('div', {
    staticClass: "p_empty"
  }, [_c('i', {
    staticClass: "fas fa-circle-check"
  }), _vm._v(" 目前運作正常，監控平台無告警 ")]) : _c('div', {
    staticClass: "p_alerts"
  }, _vm._l(_vm.allAlerts, function (a, i) {
    return _c('div', {
      key: "a".concat(i),
      staticClass: "p_alert",
      class: "is-".concat(a.level)
    }, [_c('div', {
      staticClass: "p_alert_head"
    }, [_c('span', {
      staticClass: "p_dot",
      class: "is-".concat(a.level)
    }), _vm._v(_vm._s(a.plantName) + " ")]), _c('div', {
      staticClass: "p_alert_target"
    }, [_vm._v(_vm._s(a.target))]), _c('div', {
      staticClass: "p_alert_msg"
    }, [_vm._v(_vm._s(a.msg))])]);
  }), 0)]), _c('div', {
    staticClass: "p_section"
  }, [_c('div', {
    staticClass: "p_sectionTitle"
  }, [_c('i', {
    staticClass: "fas fa-industry"
  }), _vm._v(" 案場（" + _vm._s(_vm.plants.length) + "） "), _c('small', {
    staticClass: "p_hint"
  }, [_vm._v("點卡片展開曲線與逐台比較")])]), _c('div', {
    staticClass: "p_plants"
  }, _vm._l(_vm.plants, function (p) {
    return _c('div', {
      key: p.plantNo,
      staticClass: "p_plant",
      class: ["is-".concat(p.level), {
        'is-open': !!_vm.opened[p.plantNo]
      }]
    }, [_c('div', {
      staticClass: "p_plant_head",
      on: {
        "click": function click($event) {
          return _vm.toggle(p);
        }
      }
    }, [_c('span', {
      staticClass: "p_dot",
      class: "is-".concat(p.level)
    }), _c('span', {
      staticClass: "p_plant_name"
    }, [_vm._v(_vm._s(p.name))]), _c('b-badge', {
      staticClass: "p_plant_acc",
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(p.deviceCount) + " 台")]), _c('span', {
      staticClass: "p_addr"
    }, [_vm._v(_vm._s(p.plantNo))]), _c('i', {
      staticClass: "fas ml-auto",
      class: _vm.opened[p.plantNo] ? 'fa-chevron-up' : 'fa-chevron-down'
    })], 1), _c('div', {
      staticClass: "p_plant_body"
    }, [_c('div', {
      staticClass: "p_figures"
    }, [_c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v(" 今日發電 "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-circle-info p_info",
      attrs: {
        "title": _vm.energyHint(p)
      }
    })]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.energyToday, 1)))]), _vm._v(" kWh ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v(" 電表 "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-circle-info p_info",
      attrs: {
        "title": "關口電表同區間累計，與逐台加總互為驗證；兩者差距過大代表有裝置未回報"
      }
    })]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.meterEnergyToday, 1)))]), _vm._v(" kWh ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v("即時發電功率")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.instantPower, 1)))]), _vm._v(" kW ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v("等效小時")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.yieldToday, 2)))]), _vm._v(" h ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v(" 容量 "), p.capacityDeviceMismatch ? _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-triangle-exclamation is-warn p_info",
      attrs: {
        "title": "\u7CFB\u7D71\u8A2D\u5B9A\u5BB9\u91CF\u70BA ".concat(p.capacityCount, " \u53F0\uFF0C\u5BE6\u969B\u56DE\u5831 ").concat(p.deviceCount, " \u53F0\u3002\u5BB9\u91CF\u504F\u5927\u6703\u4F7F\u7B49\u6548\u5C0F\u6642\u8207 PR \u504F\u4F4E\uFF0C\u8ACB\u6D3D\u8CC7\u8A0A\u4EBA\u54E1\u6821\u6B63")
      }
    }) : _vm._e()]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.capacity, 1)))]), _vm._v(" kWp ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v("日照")]), _c('b', [_vm._v(_vm._s(p.irradianceNow == null ? '—' : p.irradianceNow))]), _vm._v(" W/m² ")]), _c('div', {
      staticClass: "p_figure"
    }, [_c('span', [_vm._v("模組溫度")]), _c('b', [_vm._v(_vm._s(_vm.fmt(p.moduleTemp, 1)))]), _vm._v(" °C ")])]), _c('div', {
      staticClass: "p_metric"
    }, [_c('div', {
      staticClass: "p_metric_top"
    }, [_c('span', [_vm._v(" 今日 PR "), _c('i', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "fas fa-circle-info p_info",
      attrs: {
        "title": "等效小時 ÷ 當日累積日照，兩者由同一組資料點計算，統計區間一致"
      }
    })]), _c('b', {
      class: _vm.prClass(p.prToday)
    }, [_vm._v(_vm._s(p.prToday == null ? 'NA' : p.prToday + '%'))])]), _c('div', {
      staticClass: "p_bar"
    }, [_c('div', {
      staticClass: "p_bar_fill",
      class: _vm.prClass(p.prToday),
      style: {
        width: _vm.pct(p.prToday, 100)
      }
    })])])]), _c('b-collapse', {
      attrs: {
        "visible": !!_vm.opened[p.plantNo]
      }
    }, [_c('div', {
      staticClass: "p_detail"
    }, [_c('div', {
      staticClass: "p_detailTitle"
    }, [_vm._v("今日發電功率與日照")]), p.curve.length ? _c('highcharts', {
      staticClass: "p_chart",
      attrs: {
        "options": _vm.todayChart(p)
      }
    }) : _c('div', {
      staticClass: "p_noChart"
    }, [_vm._v("今日尚無遙測")]), _c('div', {
      staticClass: "p_detailTitle"
    }, [_vm._v(" 逐台逆變器比較 "), _vm.detail[p.plantNo] ? _c('small', [_vm._v(" （" + _vm._s(_vm.detail[p.plantNo].date) + "，發電量中位數 " + _vm._s(_vm.fmt(_vm.detail[p.plantNo].medianEnergy, 1)) + " kWh） ")]) : _vm._e()]), _vm.detailLoading[p.plantNo] ? _c('b-spinner', {
      staticClass: "my-2",
      attrs: {
        "small": "",
        "variant": "secondary"
      }
    }) : _vm.detailError[p.plantNo] ? _c('b-alert', {
      staticClass: "py-2 my-2",
      attrs: {
        "show": "",
        "variant": "warning"
      }
    }, [_vm._v(" " + _vm._s(_vm.detailError[p.plantNo]) + " ")]) : _vm.detail[p.plantNo] ? [_c('div', {
      staticClass: "p_note"
    }, [_c('i', {
      staticClass: "fas fa-circle-info mr-1"
    }), _vm._v(_vm._s(_vm.detail[p.plantNo].capacityNote) + " ")]), _c('div', {
      staticClass: "p_tableWrap"
    }, [_c('table', {
      staticClass: "p_table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("逆變器")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("發電 kWh")]), _c('th', [_vm._v("相對表現")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("佔比 %")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("即時發電功率 kW")]), _c('th', [_vm._v("狀態")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("機溫 °C")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("AC 電壓 V")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("AC 電流 A")])])]), _c('tbody', _vm._l(_vm.detail[p.plantNo].inverters, function (inv) {
      return _c('tr', {
        key: inv.deviceNo,
        class: {
          'row-laggard': inv.laggard || inv.stateLevel === 'fault'
        }
      }, [_c('td', {
        attrs: {
          "title": inv.model
        }
      }, [inv.laggard ? _c('i', {
        staticClass: "fas fa-arrow-trend-down is-fault mr-1"
      }) : _vm._e(), _vm._v(" " + _vm._s(inv.deviceNo) + " ")]), _c('td', {
        staticClass: "text-right"
      }, [_c('b', {
        class: inv.laggard ? 'is-fault' : ''
      }, [_vm._v(_vm._s(_vm.fmt(inv.energy, 1)))])]), _c('td', {
        staticClass: "p_miniBarCell"
      }, [_c('div', {
        staticClass: "p_miniBar"
      }, [_c('div', {
        staticClass: "p_miniBar_fill",
        class: {
          'is-low': inv.laggard
        },
        style: {
          width: _vm.pct(inv.energy, _vm.maxEnergy(_vm.detail[p.plantNo].inverters))
        }
      })])]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.share, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.power, 2)))]), _c('td', {
        staticClass: "p_state",
        class: "is-".concat(inv.stateLevel)
      }, [_vm._v(" " + _vm._s(inv.state) + " "), inv.stateLevel !== 'ok' && inv.stateCode != null ? _c('small', [_vm._v(" 代碼 " + _vm._s(inv.stateCode) + " ")]) : _vm._e()]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.temperature, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.voltage, 1)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.fmt(inv.current, 2)))])]);
    }), 0)])]), _c('div', {
      staticClass: "p_detailTitle"
    }, [_vm._v(" 告警明細 "), _c('small', [_vm._v(_vm._s(_vm.detail[p.plantNo].alarmNote))])]), !_vm.detail[p.plantNo].alarms.length ? _c('div', {
      staticClass: "p_empty"
    }, [_c('i', {
      staticClass: "fas fa-circle-check"
    }), _vm._v(" 今日沒有告警 ")]) : _c('div', {
      staticClass: "p_alarmList"
    }, _vm._l(_vm.detail[p.plantNo].alarms, function (al, i) {
      return _c('div', {
        key: "al".concat(i),
        staticClass: "p_alarm",
        class: al.state === 'closed' ? 'is-closed' : 'is-open'
      }, [_c('b-badge', {
        attrs: {
          "variant": al.state === 'closed' ? 'secondary' : 'danger'
        }
      }, [_vm._v(" " + _vm._s(al.state === 'closed' ? '已結束' : '進行中') + " ")]), _c('b', {
        staticClass: "ml-2"
      }, [_vm._v(_vm._s(al.deviceNo || '全場'))]), _c('span', {
        staticClass: "ml-2"
      }, [_vm._v(_vm._s(al.msg || al.code || '（監控平台未提供描述）'))]), _c('small', {
        staticClass: "ml-auto"
      }, [_vm._v(_vm._s(_vm.dayjs(al.at).format('MM/DD HH:mm')))])], 1);
    }), 0)] : _vm._e()], 2)])], 1);
  }), 0)])] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };